import React from "react";
import FemaleProvider from "../assets/Doctor_Female.jpg";
import MaleProvider from "../assets/Doctor_Male.jpg";
import styles from "./GenericFHIRViewerModal.module.css";

const calculateAge = (birthDate) => {
  if (!birthDate) return "Unknown";
  const dob = new Date(birthDate);
  const diff = Date.now() - dob.getTime();
  const age = new Date(diff).getUTCFullYear() - 1970;
  return age;
};

const ProviderCardExtended = ({ resource }) => {
  const photoUrl =
    resource.photo?.[0]?.url ||
    (resource.gender === "female" ? FemaleProvider :
     resource.gender === "male" ? MaleProvider :
     null);

  const name = resource.name?.[0];
  const address = resource.address?.[0];
  const geo = address?.extension?.find(e => e.url.includes("geolocation"))?.extension || [];

  const age = calculateAge(resource.birthDate);
  const qualifications = resource.qualification?.length
    ? resource.qualification.map((q, idx) => {
        const code = q.code?.text || q.code?.coding?.[0]?.display || "Qualification";
        const issuer = q.issuer?.display || "";
        return `${code}${issuer ? ` (${issuer})` : ""}`;
      })
    : ["Unknown"];

  return (
    <div className="p-4 border rounded shadow-sm bg-white">
      {/* Header with Name and Portrait */}
      <div className="d-flex align-items-start mb-4">
        <div style={{ width: "120px", height: "120px", marginRight: "1rem", flexShrink: 0 }}>
          <img
            src={photoUrl}
            alt="Provider Portrait"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
              borderRadius: "8px",
              border: "1px solid #ccc",
              backgroundColor: "#f8f9fa"
            }}
          />
        </div>
        <div>
          <h3 className="mb-1">
            {name?.prefix?.join(" ")} {name?.given?.join(" ")} {name?.family}
          </h3>
          <div className="mb-1 text-muted"><strong>Provider ID:</strong> {resource.id}</div>
          <div className="mb-1 text-muted"><strong>Gender:</strong> {resource.gender}</div>
          <div className="mb-1 text-muted"><strong>Active:</strong> {resource.active ? "Yes" : "No"}</div>
          <div className="mb-1 text-muted"><strong>Age:</strong> {age}</div>
        </div>
      </div>

      {/* Section: Identifiers */}
      <div className={styles.sectionHeader}>Identifiers</div>
      <div className="ps-5 pt-2">
        {resource.identifier?.map((id, idx) => (
          <div key={idx} className="mb-1">
            <strong>{id.system?.includes("us-npi") ? "NPI" : "Identifier"}:</strong> {id.value}
          </div>
        ))}
      </div>

      {/* Section: Location */}
      <div className={styles.sectionHeader}>Location</div>
      <div className="ps-5 pt-2">
        {address && (
          <>
            <div className="mb-1">
              <strong>Address:</strong>{" "}
              {address.line?.join(", ")}, {address.city}, {address.state} {address.postalCode}, {address.country}
              {geo.length > 0 && (
                <span className="text-muted">
                  {" "} (Lat: {geo.find(e => e.url === "latitude")?.valueDecimal}, Lon: {geo.find(e => e.url === "longitude")?.valueDecimal})
                </span>
              )}
            </div>
            <div className="mb-1">
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                  `${address.line?.join(", ")}, ${address.city}, ${address.state} ${address.postalCode}, ${address.country}`
                )}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                View on Google Maps
              </a>
            </div>
          </>
        )}
      </div>

      {/* Section: Qualifications */}
      <div className={styles.sectionHeader}>Qualifications</div>
      <div className="ps-5 pt-2">
        {qualifications.map((q, idx) => (
          <div key={idx} className="mb-1">
            <strong>Qualification:</strong> {q}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProviderCardExtended;